//** Import Modules */
import axiosWithAuth from "../../../utils/axiosWithAuth";

export function requestGetUserMessages(user_id) {
    return axiosWithAuth().request({
        method: "get",
        url: `${process.env.REACT_APP_BE_API_URL}/api/messages/threadlist/${user_id}/user`,
    });
}